/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DateTime } from "./DateTime";
export type AgreementState = {
  stage: AgreementState.stage;
} | {
  expiresAfter: DateTime;
  offeredAt: DateTime;
  stage: AgreementState.stage;
} | {
  expiredAt: DateTime;
  offeredAt: DateTime;
  stage: AgreementState.stage;
} | {
  declinedAt: DateTime;
  stage: AgreementState.stage;
};
export namespace AgreementState {
  export enum stage {
    DRAFT = "draft",
  }
}
